import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Surcharge, SurchargeType } from '@cbgms/api'
import { TFunction } from 'i18next'

export const getSurchargeDescription = (t: TFunction, surcharge: Surcharge): string => {
  if (surcharge.Description) {
    return surcharge.Description // use ERP provided description if availalbe
  }
  // fallback translate type to enum
  if (surcharge.Type) {
    return t('Enum.EnumSurchargeType', { context: surcharge.Type })
  }
  return t('Enum.EnumSurchargeType', { context: SurchargeType.Surcharge })
}

export const useSurchargeDescription = () => {
  const { t } = useTranslation()
  return useCallback((surcharge: Surcharge) => getSurchargeDescription(t, surcharge), [t])
}
